import React, {useEffect, useState} from "react";
import {useResourcePersonLessons} from "../../store/resourcePerson/resourcePersonStore";
import QuizQuestionEditor from "./QuizQuestionEditor";

export default function LessonQuizQuestionsPanel({
  courseId,
  lessonId,
  assessmentId,
  disabled,
  onError,
  onSuccess,
}) {
  const store = useResourcePersonLessons();
  const [loadedAssessmentId, setLoadedAssessmentId] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoadedAssessmentId(null);
    const loadQuestions = async () => {
      const result = await store.fetchQuestions(courseId, lessonId, assessmentId);
      if (!cancelled && result.success) setLoadedAssessmentId(String(assessmentId));
    };
    loadQuestions();
    return () => {
      cancelled = true;
    };
  }, [assessmentId, courseId, lessonId, store.fetchQuestions]);

  return (
    <div className="mt-4 rounded-lg border border-blue-100 bg-white p-4">
      <h4 className="m-0 text-sm font-semibold text-slate-900">Quiz questions</h4>
      <p className="mb-0 mt-1 text-xs text-slate-500">
        Questions are saved under this quiz assessment.
      </p>
      {store.questionsError ? (
        <p className="mt-2 text-xs text-red-700">{store.questionsError}</p>
      ) : null}
      {store.questionMutationError ? (
        <p className="mt-2 text-xs text-red-700">{store.questionMutationError}</p>
      ) : null}
      <QuizQuestionEditor
        key={assessmentId}
        questions={loadedAssessmentId === String(assessmentId) ? store.questions : []}
        loading={loadedAssessmentId !== String(assessmentId) || store.questionsLoading}
        disabled={disabled}
        onCreate={async (payload) => {
          const result = await store.createQuestion(courseId, lessonId, assessmentId, payload);
          if (!result.success) {
            onError(result.error);
            return result;
          }
          onSuccess("Quiz question added.");
          return result;
        }}
        onUpdate={async (questionId, payload) => {
          const result = await store.updateQuestion(courseId, lessonId, assessmentId, questionId, payload);
          if (!result.success) {
            onError(result.error);
            return result;
          }
          onSuccess("Quiz question updated.");
          return result;
        }}
        onDelete={async (questionId) => {
          const result = await store.deleteQuestion(courseId, lessonId, assessmentId, questionId);
          if (!result.success) {
            onError(result.error);
            return result;
          }
          onSuccess("Quiz question deleted.");
          return result;
        }}
      />
    </div>
  );
}
